<body>
  <button #dummyButton style="display: none">Dummy Button</button>
  <div class="flex-col">
    <!-- Banner container - stacks all banners at the top -->
    <div class="banner-container">
      <app-hq-banner *ngIf="showHQLoanBanner"></app-hq-banner>
      <ng-container
        *ngIf="
          activeRoute !== '/lock' &&
          activeRoute !== '/login' &&
          !activeRoute?.includes('/pending-payment') &&
          activeRoute !== '/hq/login' &&
          !isIdleWarning
        "
      >
        <app-payment-banner
          [negativeBalance]="negativeBalance"
          [restaurantId]="id"
        >
        </app-payment-banner>
        <app-subscription-banner
          *ngIf="!hqService.isHqUser()"
          [restaurantId]="id"
        ></app-subscription-banner>
      </ng-container>
    </div>

    <!-- Content area - takes remaining height -->
    <div class="content-area">
      <div
        class="pc banner-is sidebar-collapsed-{{ !!isSidebarCollapsed }}"
        *ngIf="!isIdleWarning"
      >
        <!-- Sidenav wrapper: CSS handles desktop (inline) vs mobile (off-canvas overlay) -->
        <div
          class="sidenav-wrapper"
          [class.mobile-open]="isMobileSidenavOpen"
          *ngIf="
            !(
              (activeRoute && activeRoute.includes('/pos')) ||
              (activeRoute && activeRoute.includes('/pos/order')) ||
              (activeRoute && activeRoute.includes('/pos/settle')) ||
              activeRoute == '/pos-mobile/menu' ||
              activeRoute == '/pos-mobile/cart' ||
              activeRoute == '/pos-mobile/payment' ||
              activeRoute == '/lock' ||
              activeRoute == '/login' ||
              activeRoute == '/hq/login' ||
              (activeRoute && activeRoute.includes('/order-status')) ||
              (activeRoute && activeRoute.includes('/pending-payment')) ||
              (activeRoute && activeRoute.includes('/pos/split-bill')) ||
              activeRoute == '/hq/integrations/sql-accounting' ||
              (activeRoute &&
                activeRoute.includes(
                  '/hq/integrations/sql-accounting/report-upload'
                ))
            )
          "
        >
          <!-- Mobile backdrop and hamburger-->
          <div class="sidenav-backdrop" *ngIf="isMobileSidenavOpen" (click)="closeMobileSidenav()"></div>
          <app-modern-sidenav
            *ngIf="showSideNav && !hideSidenav"
            #sideNavRef
            (change)="isLoggedOut($event)"
            (onToggleCollapse)="toggleSidebarCollapse($event)"
            (onMobileClose)="closeMobileSidenav()"
          ></app-modern-sidenav>
        </div>

        <div
          class="hamburger mobile-only"
          *ngIf="
            showHamburger &&
            isUsrLoggedIn() &&
            !hideSidenav &&
            activeRoute !== '/lock' &&
            !isMposRoute()
          "
        >
          <img
            [src]="images.MENU_2"
            alt="hamburger"
            (click)="openMobileSidenav()"
          />
        </div>

        <div
          [ngClass]="{
            main: isUsrLoggedIn() && get_user_type() === 'MM',
            possection:
              (activeRoute && activeRoute.includes('/pos')) ||
              (activeRoute && activeRoute.includes('/pos/order')) ||
              (activeRoute && activeRoute.includes('/pos/settle')) ||
              (activeRoute && activeRoute.includes('/pos/split-bill')) ||
              activeRoute == '/pos-mobile/menu' ||
              activeRoute == '/pos-mobile/cart' ||
              activeRoute == '/pos-mobile/payment' ||
              activeRoute == '/lock' ||
              (activeRoute && activeRoute.includes('/order-status')) ||
              (activeRoute && activeRoute.includes('/pending-payment')) ||
              activeRoute == '/hq/integrations/sql-accounting' ||
              (activeRoute &&
                activeRoute.includes(
                  '/hq/integrations/sql-accounting/report-upload'
                ))
          }"
        >
          <app-locked-lite *ngIf="showSystemLock"></app-locked-lite>
          <router-outlet *ngIf="!showSystemLock"></router-outlet>
        </div>
      </div>
    </div>

    <!-- Fixed nav for PC -->

    <div class="idlewarning p-t-50" *ngIf="isIdleWarning">
      <ng-lottie
        height="70vh"
        [options]="options"
        (animationCreated)="animationCreated($event)"
      ></ng-lottie>

      <div class="fs-23 fw-600">
        {{ 'APP.SCREEN_WILL_LOCK_IN' | fallbackTranslate }}
        <span class="fs-40 fw-600">{{ countdown }}</span>
        <span class="fs-32 fw-400"> {{ 'APP.SEC' | fallbackTranslate }} </span>
      </div>
      <div class="fs-20 fw-300">
        {{ 'APP.ARE_YOU_STILL_HERE' | fallbackTranslate }}
      </div>
    </div>
  </div>
</body>
